import { Controller } from "@hotwired/stimulus"

/**
 * Billing Address Cards Controller
 * Handles the radio card selection for billing addresses.
 * Uses modern radio cards pattern instead of dropdown.
 */
export default class extends Controller {
  static targets = ["card"]

  connect() {
    // Cards are self-managing via CSS peer-checked states
    // This controller is available for any additional JS logic if needed
  }

  select(event) {
    // The radio input handles selection automatically
    // CSS peer-checked classes handle visual state
    // This method is available for analytics or additional logic
  }
}
